import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const scrollToSection = (id) => {
  const element = document.getElementById(id);
  if (!element) {
    return false;
  }

  element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return true;
};

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      return undefined;
    }

    const id = hash.replace('#', '');
    let attempts = 0;
    let frameId = 0;
    let timeoutId = 0;

    const tryScroll = () => {
      if (scrollToSection(id) || attempts >= 8) {
        return;
      }

      attempts += 1;
      timeoutId = window.setTimeout(tryScroll, 50);
    };

    frameId = window.requestAnimationFrame(tryScroll);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.clearTimeout(timeoutId);
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
